import { defineStore } from 'pinia'

// 総力戦、使わないコンテンツ

interface State {
  currentAllOutWarMaster: Object
  currentAllOutWarInfo: Object
  warRuleMasters: Array<any>
}

export const useAllOutWarStore = defineStore('allOutWarStore', {
  state: (): State => ({
    currentAllOutWarMaster: {},
    currentAllOutWarInfo: {},
    warRuleMasters: [],
  }),
  getters: {
    getCurrentAllOutWarInfo: state => {
      return state.currentAllOutWarInfo
    },
    getCurrentAllOutWarMaster: state => {
      return state.currentAllOutWarMaster
    },
    getAllOutWarRule: state => {
      return id => state.warRuleMasters.find(r => r.warRuleId == id) || {}
    },
  },
  actions: {
    async fetchCurrentAllOutWarInfo() {
      //   const allOutWarInfo = await this.$nuxt.$landCupsService.getCurrentAllOutWarInfo()
      //   // 存在しない場合はnull、そうしないとpage/indexでエラーが出る
      //   if (allOutWarInfo.warId) {
      //     this.currentAllOutWarInfo = allOutWarInfo
      //   }
    },
    async fetchCurrentAllOutWarMaster(id) {
      //   if (!Object.keys(this.currentAllOutWarMaster).length) {
      //     const allOutWarMaster = await this.$nuxt.$landCupsService.getAllOutWarMaster(id)
      //     this.currentAllOutWarMaster = allOutWarMaster
      //   }
    },
    async fetchAllOutWarRuleMaster() {
      //   if (!this.warRuleMasters.length) {
      //     const allOutWarRuleMasters = await this.$nuxt.$landCupsService.getAllOutWarRuleMasters()
      //     this.warRuleMasters = allOutWarRuleMasters
      //   }
    },
  },
})
